

window.addEventListener("load", function () {
   $('#nth-ld-25-ld-bg .list-navs a').on('click', function (e) {
        e.preventDefault();

        $('#nth-ld-25-ld-bg .list-navs a').removeClass('active'); 
        $('#nth-ld-25-ld-bg .bg').removeClass('active'); 

        $(this).addClass('active');
        $('#nth-ld-25-ld-bg .bg').eq($(this).index()).addClass('active');
   });

});
